// ============================================================================
// expr.ts — résolution des `CGValue` (valeur ou expression en `x`) pour la
// géométrie contrainte. L'évaluateur arithmétique générique (`evalExpr`,
// `Scope`) vit désormais dans @jeraisonne/db (partagé avec le moteur de
// génération d'exercices paramétriques) — ce fichier ne garde que la
// résolution spécifique aux `CGValue`.
// ============================================================================

import type { CGValue } from '@jeraisonne/ai/visual-blocks';
import { evalExpr, type Scope } from '@jeraisonne/db/shared/expr';

export { evalExpr, type Scope };

/**
 * Résout une `CGValue` : renvoie le nombre tel quel, sinon évalue l'expression
 * dans la portée donnée (ou `{ x }` si un nombre est passé). Renvoie `fallback`
 * (défaut 0) si l'expression est invalide (jamais throw).
 */
export function evalCGValue(value: CGValue, scope: number | Scope, fallback = 0): number {
  if (typeof value === 'number') return value;
  try {
    const v = evalExpr(value, scope);
    return Number.isFinite(v) ? v : fallback;
  } catch {
    return fallback;
  }
}
